<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2019-12-23',
        items: [

          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-427',
            rare        : 'RR',
            name        : 'レインボー神ドレス',
            imgUrl      : '/images/items/AM-427.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'PP_RJ',
            type        : 'PR',
            point       : 2000,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-428',
            rare        : 'RR',
            name        : 'レインボー神ヒール',
            imgUrl      : '/images/items/AM-428.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'PP_RJ',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-429',
            rare        : 'RR',
            name        : 'レインボー神ティアラ',
            imgUrl      : '/images/items/AM-429.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'PP_RJ',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            rare        : 'RR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-390',
            rare        : 'PR',
            name        : 'ミステリアスキャットトップス',
            imgUrl      : '/images/items/AM-390.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-391',
            rare        : 'PR',
            name        : 'ミステリアスキャットパンツ',
            imgUrl      : '/images/items/AM-391.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-392',
            rare        : 'PR',
            name        : 'ミステリアスキャットシューズ',
            imgUrl      : '/images/items/AM-392.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-393',
            rare        : 'PR',
            name        : 'ミステリアスキャットヘアアクセ',
            imgUrl      : '/images/items/AM-393.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-394',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムレオナアナザーワンピ',
            imgUrl      : '/images/items/AM-394.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 1610,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-395',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムレオナアナザーシューズ',
            imgUrl      : '/images/items/AM-395.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-396',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムレオナアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-396.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-397',
            rare        : 'SR',
            name        : 'HTクラシックライトブルーワンピ',
            imgUrl      : '/images/items/AM-397.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'PP_HTC',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-398',
            rare        : 'SR',
            name        : 'HTクラシックライトブルーシューズ',
            imgUrl      : '/images/items/AM-398.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PP_HTC',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-399',
            rare        : 'SR',
            name        : 'HTクラシックライトブルーヘアアクセ',
            imgUrl      : '/images/items/AM-399.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PP_HTC',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            rare        : 'SR',
          }),


          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-400',
            rare        : 'SR',
            name        : 'ポッピンキャンディアップルトップス',
            imgUrl      : '/images/items/AM-400.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-401',
            rare        : 'SR',
            name        : 'ポッピンキャンディアップルパンツ',
            imgUrl      : '/images/items/AM-401.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-402',
            rare        : 'SR',
            name        : 'ポッピンキャンディアップルシューズ',
            imgUrl      : '/images/items/AM-402.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-403',
            rare        : 'SR',
            name        : 'ポッピンキャンディアップルヘアアクセ',
            imgUrl      : '/images/items/AM-403.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-404',
            rare        : 'SR',
            name        : 'ラビットハートストリートトップス',
            imgUrl      : '/images/items/AM-404.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-405',
            rare        : 'SR',
            name        : 'ラビットハートストリートスカート',
            imgUrl      : '/images/items/AM-405.png',
            kind        : 'スカート',
            color       : '水',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-406',
            rare        : 'SR',
            name        : 'ラビットハートストリートシューズ',
            imgUrl      : '/images/items/AM-406.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-407',
            rare        : 'SR',
            name        : 'ラビットハートストリートヘアアクセ',
            imgUrl      : '/images/items/AM-407.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-408',
            rare        : 'R',
            name        : 'ワイズガールパープルトップス',
            imgUrl      : '/images/items/AM-408.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-409',
            rare        : 'R',
            name        : 'ワイズガールパープルスカート',
            imgUrl      : '/images/items/AM-409.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-410',
            rare        : 'R',
            name        : 'ワイズガールパープルシューズ',
            imgUrl      : '/images/items/AM-410.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-411',
            rare        : 'R',
            name        : 'ワイズガールパープルヘアアクセ',
            imgUrl      : '/images/items/AM-411.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-412',
            rare        : 'R',
            name        : 'セブンスコーデフェミニンドレスアナザースタイル',
            imgUrl      : '/images/items/AM-412.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PP_PR',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-413',
            rare        : 'R',
            name        : 'セブンスコーデフェミニンシューズアナザースタイル',
            imgUrl      : '/images/items/AM-413.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PP_PR',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-414',
            rare        : 'R',
            name        : 'セブンスコーデフェミニンヘアアクセプラチナスタイル',
            imgUrl      : '/images/items/AM-414.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PP_PR',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            rare        : 'R',
          }),


          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-415',
            rare        : 'R',
            name        : 'レトロストライプブラックトップス',
            imgUrl      : '/images/items/AM-415.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-416',
            rare        : 'R',
            name        : 'レトロストライプブラックスカート',
            imgUrl      : '/images/items/AM-416.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-417',
            rare        : 'R',
            name        : 'レトロストライプブラックシューズ',
            imgUrl      : '/images/items/AM-417.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-418',
            rare        : 'R',
            name        : 'レトロストライプブラックヘアアクセ',
            imgUrl      : '/images/items/AM-418.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-419',
            rare        : 'N',
            name        : 'ラブリーニットブルーコルセットトップス',
            imgUrl      : '/images/items/AM-419.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-420',
            rare        : 'N',
            name        : 'ラブリーニットブルースカート',
            imgUrl      : '/images/items/AM-420.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-421',
            rare        : 'N',
            name        : 'ラブリーニットブルーシューズ',
            imgUrl      : '/images/items/AM-421.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-422',
            rare        : 'N',
            name        : 'ラブリーニットブルーヘアアクセ',
            imgUrl      : '/images/items/AM-422.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-423',
            rare        : 'N',
            name        : 'スケーターツインズシオントップス',
            imgUrl      : '/images/items/AM-423.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-424',
            rare        : 'N',
            name        : 'スケーターツインズシオンパンツ',
            imgUrl      : '/images/items/AM-424.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-425',
            rare        : 'N',
            name        : 'スケーターツインズシオンシューズ',
            imgUrl      : '/images/items/AM-425.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～メルティックスター編～',
            id          : 'AM-426',
            rare        : 'N',
            name        : 'スケーターツインズシオンヘアアクセ',
            imgUrl      : '/images/items/AM-426.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
        ],
      }
    },

    computed: {
      itemsRR () {
        return _.where(this.items, {  rare: 'RR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="RR ◆◆◆◆" color="#ff5d91" :items="itemsRR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col3>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
